export default __webpack_public_path__ + "locales/hy-AM/FillPDFDialog.json?hash=52a2840c6a1ae28da8ed4dcb805f3f2d";